
// DESCRIPTION ACCORDIONS
document.querySelectorAll('.PDP_Accordion-button').forEach(button => {
  button.addEventListener('click', () => {
    button.classList.toggle('PDP_Accordion--active');
  });
});

// PRODUCT RECOMMENDATIONS CAROUSEL INITIALIZATIONS
document.addEventListener("DOMContentLoaded", function() {
  
  if( document.readyState !== 'loading' ) { 

    let win = window.innerWidth;
    //FLICKITY INITIALIZATIONS
    setTimeout(() => {
      // PRODUCT RECOMMENDATIONS & RECENTLY VIEWED MOBILE CAROUSELS
      if (win > 900 && win <= 1340) { 
        document.querySelectorAll('.recommended-products-outer').forEach(products_carousel =>{
          let recommended_products_count = products_carousel.childElementCount;
          if (recommended_products_count > 2) {
            products_carousel.classList.add('recommended-products-carousel');
            
            let flkty = new Flickity( products_carousel, {
              watchCSS: true,
              cellAlign: 'left',
              imagesLoaded: true,
              groupCells: true,
              contain: true,
              wrapAround: false,
              pageDots: true,
              prevNextButtons: true
            });
          }
        });
      } 

      if (win <= 900) { 
        document.querySelectorAll('.recommended-products-outer').forEach(products_carousel =>{
          let recommended_products_count = products_carousel.childElementCount;
          if (recommended_products_count > 2) {
            products_carousel.classList.add('recommended-products-carousel');
            
            let flkty = new Flickity( products_carousel, {
              watchCSS: true,
              cellAlign: 'center',
              imagesLoaded: true,
              wrapAround: false,
              pageDots: false,
              prevNextButtons: false
            });
          }
        });
      }


    },250)
  }

});